// ============================================================
//  CONTEÚDO DO SITE — edite os textos aqui.
//  Tudo que aparece no site (nome, telefone, textos, serviços,
//  cidades, manifesto) vem deste arquivo.
// ============================================================

export const MARCA = {
  nome: "NB",
  nomeCompleto: "NB Imóveis",
  slogan: "Seu lar começa aqui.",
  // Logo em imagem (arquivo em /public). Deixe null para usar o texto "NB Imóveis".
  logoUrl: "/logo.png",
  creci: "CRECI 65132-F",
};

export const CONTATO = {
  telefone: "(51) 99615-2903",
  whatsapp: "5551996152903", // apenas números, com DDI 55
  email: "", // deixe vazio para não exibir
  instagram: "@imoveisnb",
  instagramUrl: "https://instagram.com/imoveisnb",
  endereco: "Av. José Antônio de Oliveira Neto, 153",
  bairro: "Centro",
  cidade: "Araricá",
  estado: "RS",
  cep: "93880-000",
  horario: "Segunda a sexta, das 8h30 às 18h · Sábado, das 9h às 12h",
  mapaEmbed:
    "https://www.google.com/maps?q=Avenida+Jos%C3%A9+Ant%C3%B4nio+de+Oliveira+Neto+153+Centro+Ararica+RS&output=embed",
};

export const CIDADES_ATENDIDAS = [
  "Araricá",
  "Nova Hartz",
  "Sapiranga",
  "Campo Bom",
  "Taquara",
  "Dois Irmãos",
  "Novo Hamburgo",
  "São Leopoldo",
  "Litoral",
];

export const SERVICOS = [
  {
    titulo: "Compra e Venda",
    texto: "Casas, apartamentos e terrenos em Araricá e região, com acompanhamento em todas as etapas até a entrega das chaves.",
  },
  {
    titulo: "Aluguel",
    texto: "Imóveis para locação com contrato claro, vistoria e suporte tanto para quem aluga quanto para quem é proprietário.",
  },
  {
    titulo: "Financiamento Habitacional",
    texto: "Orientamos você na simulação, documentação e aprovação do financiamento, para transformar o aluguel em casa própria.",
  },
  {
    titulo: "Avaliação de Imóveis",
    texto: "Avaliação justa e baseada no mercado da região, para vender ou alugar pelo valor certo e sem perder tempo.",
  },
  {
    titulo: "Consultoria",
    texto: "Tirar dúvidas antes de decidir faz diferença. Ajudamos a entender custos, prazos e o melhor caminho para o seu momento.",
  },
  {
    titulo: "Contratos e Documentação",
    texto: "Elaboração e conferência de contratos e documentos, para que a negociação aconteça com segurança para os dois lados.",
  },
];

export const HOME = {
  overline: "Araricá e Vale do Sinos",
  tituloLinha1: "Um lar para chamar",
  tituloLinha2Destaque: "de seu", // fica em vermelho
  tituloLinha2Resto: ".",
  subtitulo:
    "Casas, apartamentos e terrenos em Araricá e região. Compra, venda, aluguel e financiamento habitacional com atendimento próximo e sem complicação.",
  destaquesOverline: "Oportunidades",
  destaquesTitulo: ["Imóveis em destaque", "na região."],
  destaquesLink: "Ver todos os imóveis",
  servicosOverline: "Como podemos ajudar",
  servicosTitulo: ["Do primeiro contato", "até as chaves na mão."],
  ctaOverline: "Vamos conversar",
  ctaTitulo: ["Procurando um imóvel", "ou quer vender o seu?"],
  ctaTexto:
    "Fale com a NB. Respondemos rápido pelo WhatsApp e atendemos pessoalmente em Araricá.",
};

// Manifesto / princípios da NB (aparece na Home e em Sobre Nós)
export const MANIFESTO = {
  overline: "Nosso jeito de trabalhar",
  titulo: ["Compromisso com quem", "confia na gente."],
  itens: [
    {
      num: "01",
      titulo: "Um lar, não só um imóvel",
      texto:
        "Sabemos que por trás de cada visita existe uma família planejando o futuro. Por isso ouvimos primeiro, entendemos o que você precisa e só depois apresentamos opções que fazem sentido de verdade.",
    },
    {
      num: "02",
      titulo: "Transparência do início ao fim",
      texto:
        "Valores, prazos, documentos e custos são explicados com clareza, sem letras miúdas. Você toma decisões sabendo exatamente onde está pisando.",
    },
    {
      num: "03",
      titulo: "Conhecimento da região",
      texto:
        "Atendemos Araricá, Nova Hartz, Sapiranga, Campo Bom, Taquara, Dois Irmãos, Novo Hamburgo, São Leopoldo e imóveis no litoral. Conhecemos os bairros, os valores e as oportunidades de cada cidade.",
    },
    {
      num: "04",
      titulo: "Apoio em cada etapa",
      texto:
        "Consultoria, avaliação, contrato e financiamento habitacional. Cuidamos da parte burocrática para que você se preocupe apenas em escolher o lugar certo para morar.",
    },
  ],
};

export const SOBRE = {
  overline: "Sobre Nós",
  titulo: ["Uma imobiliária de Araricá,", "feita para as famílias da região."],
  paragrafos: [
    "A NB Imóveis nasceu em Araricá com um propósito simples: ajudar pessoas a encontrarem um lugar para morar com segurança, clareza e atendimento próximo.",
    "Trabalhamos com compra e venda, aluguel e financiamento habitacional, atendendo Araricá e as cidades vizinhas do Vale do Sinos e do Paranhana, além de imóveis no litoral gaúcho.",
    "Temos uma única sede, no Centro de Araricá, e é lá que recebemos nossos clientes pessoalmente. Preferimos atender bem a atender muitos.",
  ],
  imagem:
    "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
  imagemAlt: "Chaves de uma casa nova sendo entregues",
  regiaoOverline: "Onde atuamos",
  regiaoTitulo: ["Araricá e toda a região", "ao seu alcance."],
  regiaoTexto:
    "Nossa sede fica em Araricá, mas os imóveis que trabalhamos estão espalhados pelas cidades vizinhas e também no litoral.",
};

export const CONTATO_PAGINA = {
  overline: "Contato",
  titulo: ["Fale com a NB.", "Estamos perto de você."],
  texto:
    "Envie uma mensagem, ligue ou chame no WhatsApp. Também recebemos visitas na nossa sede, no Centro de Araricá.",
};

export const RODAPE = {
  descricao:
    "Imobiliária em Araricá/RS. Compra, venda, aluguel e financiamento habitacional em Araricá e região.",
};

export const CATALOGO = {
  overline: "Imóveis disponíveis",
  titulo: ["Encontre o imóvel certo", "para você."],
  texto:
    "Use os filtros para buscar por tipo de negócio, cidade, tipo de imóvel, faixa de preço e quartos. Não achou o que procura? Fale conosco e nós buscamos para você.",
};
